import { routeMinor } from 'src/circuits/minor-circuit/routes-minor-circuit'
import { routeAdvisingReportPdf } from './RouteAdvisingReportPdf'
import { routeAdvisorBudget } from './RouteAdvisorBudget'
import { routeAdvisorRiskProfile } from './RouteAdvisorRiskProfile'
import { routeBudget } from './RouteBudget'
import { routeEndOfCircuit } from './RouteEndOfCircuit'
import { routeLanding } from './RouteLanding'
import { routesPatrimony } from './RoutePatrimony'
import { routeSituation } from './RouteSituation'
import { routeTaxReturn } from './RouteTaxation'
import { routeInspect } from './routeInspect'
import { routeProtection } from './routeProtection'
import { routeReallocation } from './routeReallocation'
import { routeRetirementPath } from './routeRetirementPath'
import { routeTaxation } from './routes-parcours-taxation'
import { routeTransmission } from './routes-parcours-transmission'
import { routeAdvisorPatrimony } from './routesAdvisorPatrimony'
import { routeAdvisorSituation } from './routesAdvisorSituation'
import { routesAppointments } from './routesAppointments'
import { routeCustomerQualification } from './routesCustomerQualification'
import { routeDashboard } from './routesDashboard'
import { routesOnboarding } from './routesOnboarding'
import { routePatrimonyDevelopment } from './routesPatrimonyDevelopmentCircuit'
import { routesShortCircuit } from './routesShortCircuit'
import {
  routeSuitabilityReportPdf,
  routeSuitabilityReportPlayground,
} from 'src/pages/SuitabilityReport/SuitabilityReport.router'

export const ALL_ROUTES = [
  routeSuitabilityReportPlayground,
  routeSuitabilityReportPdf,
  routeAdvisingReportPdf,
  routeReallocation,
  routeLanding,
  routeEndOfCircuit,
  routeDashboard,
  routeSituation,
  ...routesPatrimony,
  routeAdvisorBudget,
  routeBudget,
  routePatrimonyDevelopment,
  routeRetirementPath,
  routeTransmission,
  routeCustomerQualification,
  routeAdvisorPatrimony,
  routeAdvisorSituation,
  routesShortCircuit,
  routesOnboarding,
  routeProtection,
  routeAdvisorRiskProfile,
  routeInspect,
  routeTaxation,
  ...routesAppointments,
  routeMinor,
  routeTaxReturn,
]
